module.exports = __webpack_public_path__ + "static/such-a-fun-age-82873dfc0f69f7fb48ea006162209d4b.jpg";